module.exports = __webpack_public_path__ + "img/icon_vod_share_w.0592fe2a.svg";